import React, { useState, useEffect } from "react";

export const useLabelFormated = (field) => {
  const [labelFormated, setLabelFormated] = useState("");

  useEffect(() => {
    if (typeof field?.text === "string") {
      if (field?.text?.includes(":::")) {
        setLabelFormated(field?.text?.split("::")[0] + ":");
      } else if (field?.text?.includes("::")) {
        setLabelFormated(field?.text?.split("::")[0]);
      }
    }
    if (
      typeof field?.text === "object" &&
      Object.keys(field?.text).length > 0
    ) {
      Object.keys(field?.text).forEach((key) => {
        if (field?.text[key]?.includes(":::")) {
          setLabelFormated(field?.text[key]?.split("::")[0] + ":");
        } else if (field?.text[key]?.includes("::")) {
          setLabelFormated(field?.text[key]?.split("::")[0]);
        }
      });
    }
  }, [field]);

  return { labelFormated };
};
